import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/assessments/$assessmentId/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/assessments/$assessmentId/"!</div>;
}
